import utils from "./Utils.js";
import plotMgrInstance from "./PlotMgr.js"
import * as d3 from "d3";
import {Plot} from "./Plot.js"

class BarPlot extends Plot{
  
  constructor(initParams) {
    super(initParams)
  }

    addBarPlot(newData, idForPlotCreation, keyForPlotCreation, layoutType, idKeyValue = undefined, flipAxis = true, chartFormatting) {
      try {
        var scope = this;
        let formatting = { ...utils.defaultFormatting, ...(chartFormatting || {}) };
        scope.plotKey = keyForPlotCreation;
        scope.dataObj = {};
        scope.dataArr = [];

        scope.keys.x = keyForPlotCreation;
        scope.keys.y = idKeyValue;

        scope.flipAxis = flipAxis;
        scope.formatting = formatting;
        
        scope.canvas.innerHTML = "";

        //Create plot for numerical data
        if (layoutType == 'value') {
          if (keyForPlotCreation == 'string' || keyForPlotCreation == 'bool') {
            error.textContent = "Failed to add donut plot for string using number layout type"
          }
          else {
            let response = utils.filterNumberTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
            if (response.status == 'success') {
              scope.dataObj = response.data;
            }
          }
        }
        //Create plot for categrotical data
        else {
          let response = utils.filterOtherTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
          if (response.status == 'success') {
            scope.dataObj = response.data;
          }
        }

        scope.dataArr = scope.dataObj.data;

        scope.dataArr.forEach(element => {
          scope.data[element.key] = element;
          element.ids.forEach(id => {
            scope.elements[id] = element.key;
          });
        });

        let data = scope.dataArr
        
        //Determine necessary Y-Axis Offset from Left Edge
        //Number of characters in the longest dependent variable
        const independentVariableLength = utils.getMaxCharactersForString(data.map(d => d.key))

        // Set the dimensions of the graph
        let axisAngleRadians = utils.toRadians(scope.formatting.axisAngle)
        let w = scope.canvas.offsetWidth - scope.margin.left - scope.margin.right
        let h = scope.canvas.offsetHeight - scope.margin.top - scope.margin.bottom

        //Determine required padding and new dimensions of chart so text doesn't get cut off 
        //Independent Axis on Left
        scope.paddingX = independentVariableLength*Math.abs(Math.cos(axisAngleRadians))*5
        scope.paddingY = 0

        let width = w - scope.paddingX
        let height = h

        //Independent Axis on Bottom
        if (scope.flipAxis == true) {
          scope.paddingX = 0
          scope.paddingY = independentVariableLength*Math.sin(axisAngleRadians)*5
          width = w
          height = h - scope.paddingY
        }

        //Determine max number of ticks to use vertically and horizontally
        let maxTicksVertically = height/20
        let maxTicksHorizontally = width/20

        let dimensions = "0 0 " + scope.canvas.offsetWidth + " " + scope.canvas.offsetHeight;

        // Append the svg object to the body of the page
        scope.svg = d3.select(scope.canvas)
          .append('svg')
          .attr("viewBox", dimensions)
          .attr("preserveAspectRatio", "xMinYMin meet")
          .append('g')
          .attr('transform', 'translate(' + scope.margin.left + ',' + scope.margin.top + ')');

        scope.tooltip = d3.select(scope.canvas).append("div");
        utils.formatTooltipDefault(scope.tooltip, scope.defaultColor);

        let items = {};
        let axisX = {};
        let axisY = {};
        let gridX = {};
        let gridY = {};

        //Independant Variable on bottom
        if (scope.flipAxis == true) {
          
          // █▀▀ █▀▀ ▄▀▄ █   █▀▀ 
          // ▄██ █▄▄ █▀█ █▄▄ ██▄ 

          // Independant Variable
          let x = d3.scaleLinear()
            .range([height, 0])
            .domain([scope.dataObj.settings.min, scope.dataObj.settings.max])
            

          // Dependent Variable
          let y = d3.scaleBand()
            .domain(scope.dataArr
              .map(d => d.key)
              .sort((a, b) => {
                  let numA = parseFloat(a);
                  let numB = parseFloat(b);
                  let isNumA = !isNaN(numA);
                  let isNumB = !isNaN(numB);
      
                  // Both are numbers, sort numerically
                  if (isNumA && isNumB) return numA - numB;
      
                  // One is a number, prioritize numbers over strings
                  if (isNumA) return -1;
                  if (isNumB) return 1;
      
                  // Both are non-numbers, sort alphabetically
                  return a.localeCompare(b);
              })
            )
            .range([0, width])

          // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
          // █▀█ █ █ ▄█▄ ▄██ 

          //Bottom Axis (Dependent variable)
          axisX = scope.svg.append('g')
            .attr('name', 'axisX')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(y)
            .tickValues(y.domain().filter((d, i) => i % Math.ceil(y.domain().length / maxTicksHorizontally) === 0))
          );
          
          //Left Axis (Independent variable)
          axisY = scope.svg.append('g')
            .attr('name', 'axisY')
            .call(d3.axisLeft(x).ticks(maxTicksVertically));

            // █▀▀ █▀█ ▀█▀ █▀▄ 
            // █▄█ █▀▄ ▄█▄ █▄▀ 

            gridX = scope.svg.append("g")
              .attr('name', 'gridX')
              .call(d3.axisLeft(x).tickSize(-width).tickFormat("").ticks(maxTicksVertically));


            // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
            // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

            //Bars
            items = scope.svg.selectAll('myRect')
              .data(scope.dataArr)
              .enter()
              .append('rect')
              .attr('x', function (d) { return y(d.key); })
              .attr('y', function (d) { return x(d.value); })
              .attr('rx', scope.defaultRadius)
              .attr('ry', scope.defaultRadius)
              .attr('width', y.bandwidth())
              .attr('height', function (d) { return height - x(d.value); })
              .attr("data-id", function (d, i) {
                scope.groups[d.key] = this;
                return d.key;
              });
          }
          else {                  
            // Dependent Variable
            let y = d3.scaleBand()
              .domain(scope.dataArr
              .map(d => d.key)
              .sort((a, b) => {
                  let numA = parseFloat(a);
                  let numB = parseFloat(b);
                  let isNumA = !isNaN(numA);
                  let isNumB = !isNaN(numB);
      
                  // Both are numbers, sort numerically
                  if (isNumA && isNumB) return numB - numA;
      
                  // One is a number, prioritize numbers over strings
                  if (isNumA) return -1;
                  if (isNumB) return 1;
      
                  // Both are non-numbers, sort alphabetically
                  return b.localeCompare(a);
              })
            )
            .range([0, height])

            // Independent Variable
            let x = d3.scaleLinear()
            .range([width, 0])
            .domain([scope.dataObj.settings.max, scope.dataObj.settings.min])

            // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
            // █▀█ █ █ ▄█▄ ▄██   

            //Bottom Axis (dependent varaible)
            axisY = scope.svg.append('g')
              .attr('name', 'axisY')
              .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
              .call(d3.axisBottom(x));

            //Left Axis (independent variable)
            axisX = scope.svg.append('g')
              .attr('name', 'axisX')
              .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
              .call(d3.axisLeft(y)
                .tickValues(y.domain().filter((d, i) => i % Math.ceil(y.domain().length / maxTicksVertically) === 0)) // Apply tick values
              );

            // █▀▀ █▀█ ▀█▀ █▀▄ 
            // █▄█ █▀▄ ▄█▄ █▄▀ 

            gridX = scope.svg.append("g")
              .attr('name', 'gridX')
              .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
              .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

            // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
            // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

            //Bars
            items = scope.svg.selectAll('myRect')
              .data(scope.dataArr)
              .enter()
              .append('rect')
              .attr('x', function (d) { return x(Math.min(0, d.value)); })
              .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
              .attr('y', function (d) { return y(d.key); })
              .attr('rx', scope.defaultRadius)
              .attr('ry', scope.defaultRadius)
              .attr('width', function (d) { return Math.abs(x(d.value) - x(0)); })
              .attr('height', y.bandwidth())
              .attr("data-id", function (d, i) {
                scope.groups[d.key] = this;
                return d.key;
              });
          }

          // █▀▀ █▀█ █▀█ █▄ ▄█ ▄▀▄ ▀█▀ ▀█▀ ▀█▀ █▄ █ █▀▀ 
          // █▀  █▄█ █▀▄ █ ▀ █ █▀█  █   █  ▄█▄ █ ▀█ █▄█ 

          utils.formatFillItem(items, scope.tooltip, scope.defaultColor);
          utils.formatAxis(axisX, formatting.xAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
          utils.formatAxis(axisY, formatting.yAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
          utils.formatGrid(gridX, formatting.xGrid, scope.gridColor, scope.gridOpacity);
          utils.formatGrid(gridY, formatting.yGrid, scope.gridColor, scope.gridOpacity);

          let returnValue = {
            'status': 'success',
            'message': 'Bar plot added'
          }
          scope.plotAdded = true
          return returnValue;
      }
      catch (err) {
        let returnValue = {
          'status': 'failed',
          'message': 'Failed to add bar plot.' + err.message
        }
        return returnValue;
      }
    }

    resizeChart() {
      let scope = this;
      
      // Get new dimensions
      let w = scope.canvas.offsetWidth - scope.margin.left - scope.margin.right - 20
      let h = scope.canvas.offsetHeight - scope.margin.top - scope.margin.bottom - 20
      
      //Independent Axis on Bottom
      let width = w - scope.paddingX;
      let height = h;

      //Independent Axis on Left
      if (scope.flipAxis) {
        width = w;
        height = h - scope.paddingY;
      }

      //Determine max number of ticks to use vertically and horizontally
      let maxTicksVertically = height/20
      let maxTicksHorizontally = width/20
  
      // Update SVG viewBox
      d3.select(scope.canvas).select("svg")
        .attr("viewBox", `0 0 ${scope.canvas.offsetWidth} ${scope.canvas.offsetHeight}`);
    
      if (scope.flipAxis) {

        // █▀▀ █▀▀ ▄▀▄ █   █▀▀ 
        // ▄██ █▄▄ █▀█ █▄▄ ██▄ 

        // Independant Variable
        let x = d3.scaleLinear()
        .range([height, 0])
        .domain([scope.dataObj.settings.min, scope.dataObj.settings.max])

        // Dependent Variable
        let y = d3.scaleBand()
          .domain(scope.dataArr
            .map(d => d.key)
            .sort((a, b) => {
                let numA = parseFloat(a);
                let numB = parseFloat(b);
                let isNumA = !isNaN(numA);
                let isNumB = !isNaN(numB);
    
                // Both are numbers, sort numerically
                if (isNumA && isNumB) return numA - numB;
    
                // One is a number, prioritize numbers over strings
                if (isNumA) return -1;
                if (isNumB) return 1;
    
                // Both are non-numbers, sort alphabetically
                return a.localeCompare(b);
            })
          )
          .range([0, width])

        // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
        // █▀█ █ █ ▄█▄ ▄██ 

        //Bottom Axis (Dependent variable)
        d3.select(scope.canvas).select("[name='axisX']")
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(y)
        .tickValues(y.domain().filter((d, i) => i % Math.ceil(y.domain().length / maxTicksHorizontally) === 0)))
          
        //Left Axis (Independent variable)
        d3.select(scope.canvas).select("[name='axisY']")
          .call(d3.axisLeft(x).ticks(maxTicksVertically));

        // █▀▀ █▀█ ▀█▀ █▀▄ 
        // █▄█ █▀▄ ▄█▄ █▄▀ 

        // Update grids
        d3.select(scope.canvas).select("[name='gridX']")
          .call(d3.axisLeft(x).tickSize(-width).tickFormat(""));

        // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
        // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

        // Update bars
        d3.select(scope.canvas).selectAll('rect')
          .attr('x', d => y(d.key))
          .attr('y', d => x(d.value))
          .attr('width', y.bandwidth())
          .attr('height', d => height - x(d.value));

      } else {
        // Dependent Variable
        let y = d3.scaleBand()
        .domain(scope.dataArr
          .map(d => d.key)
          .sort((a, b) => {
              let numA = parseFloat(a);
              let numB = parseFloat(b);
              let isNumA = !isNaN(numA);
              let isNumB = !isNaN(numB);
  
              // Both are numbers, sort numerically
              if (isNumA && isNumB) return numB - numA;
  
              // One is a number, prioritize numbers over strings
              if (isNumA) return -1;
              if (isNumB) return 1;
  
              // Both are non-numbers, sort alphabetically
              return a.localeCompare(b);
          })
        )
        .range([0, height])

        // Independent Variable
        let x = d3.scaleLinear()
        .range([width, 0])
        .domain([scope.dataObj.settings.max, scope.dataObj.settings.min])

        // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
        // █▀█ █ █ ▄█▄ ▄██   

        //Bottom Axis (independent varaible)
        d3.select(scope.canvas).select("[name='axisY']")
          .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
          .call(d3.axisBottom(x));

        //Left Axis (dependent variable)
        d3.select(scope.canvas).select("[name='axisX']")
        .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
        .call(d3.axisLeft(y)
          .tickValues(y.domain().filter((d, i) => i % Math.ceil(y.domain().length / maxTicksVertically) === 0)) // Apply tick values
        );
            
      // █▀▀ █▀█ ▀█▀ █▀▄ 
      // █▄█ █▀▄ ▄█▄ █▄▀ 

        // Update grids
        d3.select(scope.canvas).select("[name='gridX']")
            .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
            .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

        // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
        // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

        // Update bars
        d3.select(scope.canvas).selectAll('rect')
            .attr('x', d => x(Math.min(0, d.value)))
            .attr('y', d => y(d.key))
            .attr('width', d => Math.abs(x(d.value) - x(0)))
            .attr('height', y.bandwidth());
      }
  
      // Optionally format axes, grids, and bars
      utils.formatAxis(d3.select(scope.canvas).select("[name='axisX']"), scope.formatting.xAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
      utils.formatAxis(d3.select(scope.canvas).select("[name='axisY']"), scope.formatting.yAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
      utils.formatGrid(d3.select(scope.canvas).select("[name='gridX']"), scope.formatting.xGrid, scope.gridColor, scope.gridOpacity);
      utils.formatGrid(d3.select(scope.canvas).select("[name='gridY']"), scope.formatting.yGrid, scope.gridColor, scope.gridOpacity);
  }

    //  ████  ███  █      ███  ████     ████  █   █ 
    // █     █   █ █     █   █ █   █    █   █  █ █  
    // █     █   █ █     █   █ ████     ████    █   
    // █     █   █ █     █   █ █   █    █   █   █   
    //  ████  ███  █████  ███  █   █    ████    █   

    getHighlightedElement(group){
      return d3.select(group)
    }


    // █████ █████ █     █████  ████ █████ 
    // █     █     █     █     █       █   
    // █████ ████  █     ████  █       █   
    //     █ █     █     █     █       █   
    // █████ █████ █████ █████  ████   █   


    selectElements(elementIDs) {
        let scope = this;

        if (scope.highlightElementFlagCheck) {
            if (scope.svg != undefined) {
                if (elementIDs) {
                    let elems = {};
                    elementIDs.forEach(id => {

                        let key = scope.elements[id];

                        if (!elems[key]) elems[key] = [];
                        elems[key].push(id);

                    });

                    Object.keys(elems).forEach(key => {
                        var element = d3.select(scope.groups[key]);
                        if (scope.data[key]) {
                            if (scope.data[key].ids.length === elems[key].length) {
                                scope.applySelectionColor(element);
                            }
                            else {
                                scope.applyPartialSelectionColor(element);
                            }
                        }
                    });
                }
            }
        }
    }


    // █   █ █████  ████ █   █ █     █████  ████ █   █ █████ 
    // █   █   █   █     █   █ █       █   █     █   █   █   
    // █████   █   █  ██ █████ █       █   █  ██ █████   █   
    // █   █   █   █   █ █   █ █       █   █   █ █   █   █   
    // █   █ █████  ███  █   █ █████ █████  ███  █   █   █   


  buildTooltipContent(id) {
    let scope = this;
    let content = "<strong>" + id + "</strong> | " + scope.data[id].ids.length + "<br/>";
    return content;
  }
}

export { BarPlot }
